import React from 'react'
import Chat from '../components/Chat'
const Home = () => {
  return (
    <div>
        <Chat></Chat>
    </div>
  )
}

export default Home